import api from "./api";

// Capa de servicios API del dominio "SMTP" (configs + plantillas de email) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Plantillas de email ---
export const listEmailTemplates = (purpose) =>
  api.get(purpose ? `/smtp/templates?purpose=${purpose}` : "/smtp/templates");
export const findEmailTemplateById = (id) => api.get(`/smtp/templates/${id}`);
export const createEmailTemplate = (payload) => api.post("/smtp/templates", payload);
export const updateEmailTemplate = (id, payload) =>
  api.put(`/smtp/templates/${id}`, payload);
export const deleteEmailTemplate = (id) => api.delete(`/smtp/templates/${id}`);

// --- Configuraciones SMTP ---
export const listSMTPConfigs = () => api.get("/smtp/configs");
export const findSMTPConfigById = (id) => api.get(`/smtp/configs/${id}`);
export const createSMTPConfig = (payload) => api.post("/smtp/configs", payload);
export const updateSMTPConfig = (id, payload) =>
  api.put(`/smtp/configs/${id}`, payload);
export const deleteSMTPConfig = (id) => api.delete(`/smtp/configs/${id}`);
export const testSMTPConfig = (id) => api.post(`/smtp/configs/${id}/test`);
